<template>
	<section>
		<div class="box d-print-none">
			<div class="level">
				<div class="level-left">
					<div v-if="showChanger" class="level-item listing-selector">
						<b-select v-model="hospitalid">
							<option
								v-for="option in hospitals"
								:key="option.id"
								:value="option.id"
								v-text="option.name"
							/>
						</b-select>
					</div>
				</div>
				<div class="level-right">
					<report-date-picker class="level-item"></report-date-picker>
				</div>
			</div>
		</div>
		<layout v-if="layout" :page="layout" :hospital-id="hospitalid" />
		<div v-else>
			<h1 v-if="msg" class="title" v-text="msg" />
			<panel heading="Notifications">
				<b-notification type>
					<h2 class="subtitle">Welcome to DailyCare!</h2>
					<br />
					<router-link
						to="/organisations/listings"
						class="button is-primary"
						>View my listings</router-link
					>
				</b-notification>
				<b-notification type>
					<h2 class="subtitle">Logged in as a Super user</h2>
				</b-notification>
			</panel>
		</div>
	</section>
</template>

<script>
import Panel from "@/components/AppPanel";
import Layout from "@shared/Charts/Layouts/Page";
import ReportDatePicker from "@shared/components/ReportDatePicker";
import { sortBy } from "lodash";

export default {
	name: "SuperDashboard",
	components: { Panel, Layout, ReportDatePicker },
	data() {
		return {
			msg: "",
			hospitalid: null
		};
	},
	computed: {
		layout() {
			return this.dashboards && this.dashboards.length
				? this.dashboards[0]
				: null;
		},
		hospitals() {
			const hospitals = sortBy(this.$store.getters.hospitalsList, [
				"name"
			]);
			return [{ id: 0, name: "All hospitals" }, ...hospitals];
		},
		showChanger() {
			return this.hospitals.length > 0;
		},
		dashboards() {
			return this.$store.getters.userDashboardsList;
		}
	},
	created() {
		this.fetchHospitals();
	},
	methods: {
		async fetchHospitals() {
			await this.$store.dispatch("hospitalsLoad");

			if (this.hospitals.length) {
				this.hospitalid = this.hospitals[0].id;
			}
		}
	}
};
</script>

<style scoped>
.dashboard {
	min-height: 700px;
}
</style>
